<tcm-main-frame titleKey="Screens.Patients.InfoWidget.SendSms">
    <ng-container commands>
        <button class="btn btn-complete me-2"
                (click)="sendSms()">{{'Screens.Patients.InfoWidget.SendSms' | translate}}</button>
        <button class="btn btn-default me-4"
                (click)="back()">{{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}</button>
    </ng-container>
    <ng-container body>
        <tcm-details-layout>
            <div form-area>
                <form #detailsForm="ngForm">
                    <div class="tcm-details-panel">
                        <div class="row">
                            <div class="col">
                                <waf-select-input #smsTemplateInfo
                                                  name="smsTemplate"
                                                  [label]="'Common.SearchColumnsAndDetailsFields.Template' | translate"
                                                  [(ngModel)]="smsTemplateId"
                                                  (ngModelChange)="onSmsTemplateChanged(smsTemplateInfo.selectedOptions)"
                                                  [options]="smsTemplates"
                                                  [optionsLoaderFunc]="getSmsTemplateOptionsFunc"
                                                  required="true"></waf-select-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <waf-text-input name="smsText"
                                                [label]="'Screens.Patients.InfoWidget.SmsText' | translate"
                                                [(ngModel)]="smsText"
                                                [multiline]="true"
                                                [disabled]="true"></waf-text-input>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </tcm-details-layout>
    </ng-container>
</tcm-main-frame>